import { useLanguage } from '../context/LanguageContext'

// Keeps the CMS nodes written in the current language (nodes without one are Greek).
export const useLocalizedNodes = (nodes = []) => {
  const { lang } = useLanguage()
  return nodes.filter((node) => (node.language?.code || 'EL') === lang)
}
